import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取列表
 * @param data
 */
export const getHelpList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/getHelpList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 获取列表条数
* @param data
*/
export const getHelpListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/getHelpListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取详情
 * @param data
 */
export const detail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 启用
* @param data
*/
export const enable = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/enable`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 禁用
 * @param data
 */
export const disable = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/disable`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 删除
* @param data
*/
export const deleteHelp = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/delete`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 取消置顶
* @param data
*/
export const notTop = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/notTop`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 置顶
* @param data
*/
export const top = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/top`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 新增保存文档
* @param data
*/
export const insert = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/help/insert`,
    method: 'post',
    data
  })

/**
* 上传文件
* @param data
*/
export const fileUploadPost = (data: any) =>
  request({
    url: `${apiUrl.api}/core/oss/file/fileUploadPost`,
    method: 'post',
    data
  })
